import { ViewIcon } from 'components/icons';
import { ButtonCTA } from 'components/ui';
import { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { usePageTitle } from 'utils';

export default function AddStore() {
  usePageTitle('Add new store | Segments');
  const formRef = useRef(null);
  const history = useHistory();

  function getStoreName(storeName: string | undefined) {
    if (!!!storeName) return '';
    return storeName
      .trim()
      .replace('.myshopify.com', '')
      .replace('https://', '')
      .replace('http://', '')
      .replace(' ', '-')
      .toLowerCase();
  }

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const { store } = e.target;
    history.replace(`/integrations/shopify?shop=${getStoreName(store.value)}`);
  };

  return (
    <main className="w-full max-w-screen-xl px-5 mx-auto mt-10 lg:mt-24">
      <div className="flex justify-between ">
        <div className="flex items-center">
          <img
            src="/assets/logo-segments.png"
            alt="logo"
            className="w-8 h-8 md:w-10 md:h-10"
          />
          <h2 className="ml-3 text-2xl font-normal leading-7 tracking-segments_logo text-segments-dark">
            Segments
          </h2>
        </div>
        <div>
          <Link
            to="/account"
            className="block px-5 py-2 text-black bg-segments-gray rounded-segments-32px text-segments-13px focus:outline-none"
          >
            <div className="flex items-center space-x-2">
              <ViewIcon className="w-4 h-4 text-black" />
              <span className="font-bold">View account</span>
            </div>
          </Link>
        </div>
      </div>

      <form
        className="flex flex-col items-center justify-center max-w-xl mx-auto mt-14"
        ref={formRef}
        onSubmit={handleSubmit}
      >
        <div>
          <h3 className="text-2xl font-bold text-left">Enter Shopify URL</h3>
          <p className="mt-4 leading-6">
            If your store is https://awesome-stuff.myshopify.com, just enter
            awesome-stuff. You will automatically start on a free 14-day trial
            after approving the installation from Shopify.
          </p>
          <p className="mt-2 text-black text-opacity-50 text-segments-13px">
            If you are not redirected to Shopify, please sign in to your store
            on Shopify first and try installing again..
          </p>
        </div>
        <div className="flex items-center w-full mt-10 space-x-1">
          <p className="text-2xl text-black text-opacity-50">https://</p>
          <input
            className="w-full h-12 px-5 placeholder-black border border-black border-solid border-opacity-20 rounded-segments-10px placeholder-opacity-30 focus:border-segments-accent-color-1 focus:ring-segments-accent-color-1 disabled:bg-segments-gray"
            name="store"
            type="text"
            placeholder="your-store"
            spellCheck={false}
            required
          />
          <p className="text-2xl text-black text-opacity-50">.myshopify.com</p>
        </div>
        <div className="items-center justify-between w-full mt-4 lg:mt-10 lg:pr-20 lg:flex">
          <span className="text-black text-segments-13px">
            or install directly from the Shopify App Store
          </span>
          <div className="mt-5 lg:mt-0">
            <ButtonCTA variant="main" type="submit">
              <span className="px-10">Continue</span>
            </ButtonCTA>
          </div>
        </div>
      </form>
    </main>
  );
}
